import React from 'react';
import analyticsLib from '@nerdwallet/analytics';
import { ImpressionContext } from '@nerdwallet/analytics/react/impression';
import { ElementInteraction } from '@nerdwallet/nw-client-lib/tracking';
import { Text, Accent, Link, Box } from '@nerdwallet/currency';
import { getEmptyState } from '../../lib/product-constants';
import { AddEntityToCompare } from '../add-entity-to-compare/add-entity-to-compare';
import { ACTION, ENTITY_NAME, EVENT_TYPES, INTERACTION_TYPE } from '../../lib/analytics-constants';
import styles from '../comparison-grid.module.less';

var CompareGridEmptyState = function CompareGridEmptyState(_ref) {
  var canAdd = _ref.canAdd,
      hideComparisonGridPanel = _ref.hideComparisonGridPanel,
      productType = _ref.productType,
      shouldAddEntityRender = _ref.shouldAddEntityRender,
      tabName = _ref.tabName,
      tabPosition = _ref.tabPosition,
      updateShouldShowSearch = _ref.updateShouldShowSearch,
      emptyState = _ref.emptyState;

  var emptyStateBackClick = function emptyStateBackClick(impressionId) {
    analyticsLib.track(EVENT_TYPES.ELEMENT_INTERACTED, {
      action: ACTION.CLOSE,
      entity_name: ENTITY_NAME.COMPARISON_GRID_BACK,
      interaction_type: INTERACTION_TYPE.PRESS,
      impression_id: impressionId
    });
    hideComparisonGridPanel();
  };

  if (!canAdd) {
    var _getEmptyState = getEmptyState(productType),
        headerText = _getEmptyState.headerText,
        bodyText = _getEmptyState.bodyText,
        linkText = _getEmptyState.linkText;

    return /*#__PURE__*/React.createElement(ImpressionContext.Consumer, null, function (impressionContext) {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.tabContentEmpty
      }, typeof emptyState === 'function' ? emptyState(function () {
        return emptyStateBackClick(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
      }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
        className: styles.tabContentEmpty__header
      }, /*#__PURE__*/React.createElement(Accent, null, headerText)), /*#__PURE__*/React.createElement(Box, {
        className: styles.tabContentEmpty__body
      }, /*#__PURE__*/React.createElement(Text, {
        component: "p"
      }, bodyText)), /*#__PURE__*/React.createElement(ElementInteraction, {
        elementCategory: "close",
        elementName: ENTITY_NAME.COMPARISON_GRID_BACK,
        id: ENTITY_NAME.COMPARISON_GRID_BACK,
        type: "CLICK"
      }, /*#__PURE__*/React.createElement(Link, {
        className: styles.tabContentEmpty__link,
        onClick: function onClick() {
          return emptyStateBackClick(impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId);
        }
      }, linkText))));
    });
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.addNewEntity__gridContainer
  }, /*#__PURE__*/React.createElement(AddEntityToCompare, {
    canAdd: canAdd,
    isCompareGridEmpty: true,
    shouldAddEntityRender: shouldAddEntityRender,
    tabName: tabName,
    tabPosition: tabPosition,
    updateShouldShowSearch: updateShouldShowSearch,
    productType: productType
  }));
};

export default CompareGridEmptyState;